import React, { useEffect, useRef } from 'react';
import Button from './button';
import downloadImageWhite from '../../static/images/download_icon_white.png';
import downloadImageBlack from '../../static/images/download_icon_black.png';
// import convertHierarchyToOTUTable from '../../utils/convertHierarchyToOTUTable';
import convertHierarchyToOTUTable from '../../utils/hierarchyToTable';
import { useTheme } from '../../theme/ThemeContext';


import * as d3 from 'd3';

// export default function SunburstPlot({ taxaData, highlightTaxon=null, depth = 3 }) {
export default function SunburstPlot({ taxaData, highlightTaxon = null, depth = 3, runAssemblyID = null, setHighlightTaxon }) {
    // console.log("abcd", taxaData);


    // export default function SunburstPlot({ taxaData, depth = 6 }) {
    const pathRef = useRef();
    const labelRef = useRef();
    const { theme } = useTheme();

    const downloadImage = theme.name === 'light' ? downloadImageBlack : downloadImageWhite

    const svgRef = useRef();

    const downloadSVG = () => {
        const svgElement = svgRef.current;
        const serializer = new XMLSerializer();
        const source = serializer.serializeToString(svgElement);

        const blob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = 'sunburst-plot.svg';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
    };


    const downloadOTU = () => {
        console.log('Download OTU TSV');
        const otuTable = convertHierarchyToOTUTable(taxaData);
        const header = 'Count\tTaxon\n';
        const tsvContent = otuTable.reduce((acc, row) => {
            return acc + `${row.count}\t${row.taxon}\n`;
            // return acc + `${row.abundance}\t${row.taxon}\n`;
        }, header);

        const blob = new Blob([tsvContent], { type: 'text/tab-separated-values' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // a.download = 'otu_table.tsv';
        a.download = (runAssemblyID) ? `${runAssemblyID}_otu_table.tsv` : 'otu_table.tsv';

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // console.log('OTU TSV download initiated');
    };

    const depthColors = d3.scaleOrdinal()
        .domain(d3.range(depth + 1))
        .range(d3.schemeSet2);


    const getColor = (d) => {
        if (highlightTaxon && d.data.name === highlightTaxon) {
            // return 'red';
            return 'green';
        }
        const baseColor = depthColors(d.depth);
        const siblings = d.parent ? d.parent.children : [d];
        const index = siblings.indexOf(d);

        const colorScale = d3.scaleSequential()
            .domain([0, siblings.length - 1])
            .interpolator(t => d3.interpolateRgb(baseColor, "#fff")(t * 0.7));

        return colorScale(index);
    };




    const createSunburst = (data) => {

        const validateAndFixHierarchy = (node) => {
            if (!node.children || node.children.length === 0) return;

            // Recursively fix children first
            node.children.forEach(validateAndFixHierarchy);

            // Calculate sum of children's counts
            const childrenSum = node.children.reduce((sum, child) => sum + (child.count || 0), 0);

            // If parent has no count or count is less than children sum, fix it
            if (!node.count || node.count < childrenSum) {
                // console.warn(`Fixing node "${node.name}": count=${node.count}, children sum=${childrenSum}`);
                node.count = childrenSum;
            }
        };

        // Call this before creating the hierarchy
        validateAndFixHierarchy(data);


        const width = 800;
        const height = 900;
        // Calculate radius based on depth
        const baseRadius = width / 4.3;
        const radius = baseRadius * (1 - (depth * 0.1)); // Reduce radius by 10% for each depth level

        // Ensure minimum radius
        const minRadius = baseRadius * 0.3; // Set minimum radius to 30% of base radius
        const finalRadius = Math.max(radius, minRadius);

        const hierarchy = d3.hierarchy(data)
            .sum(d => d.count || 0)
            .sort((a, b) => b.value - a.value);

        let targetNode = null;

        hierarchy.each(d => {
            if (d.data.name === highlightTaxon) {
                targetNode = d;
            }
        });




        const root = d3.partition()
            // .size([2 * Math.PI, radius])(hierarchy);
            .size([2 * Math.PI, hierarchy.height + 1])(hierarchy);


        // console.log("Node hierarchy structure:");
        // root.each(d => {
        //     if (d.parent) {
        //         const parentSpan = d.parent.x1 - d.parent.x0;
        //         const childSpan = d.x1 - d.x0;
        //         const coveragePercent = (childSpan / parentSpan) * 100;
        //         console.log(
        //             `${d.data.name} (${d.value}) covers ${coveragePercent.toFixed(1)}% of parent ${d.parent.data.name} (${d.parent.value})`
        //         );
        //     }
        // });

        root.each(d => d.current = d);

        const svg = d3.select(svgRef.current)
            .attr('viewBox', [-width / 2, -height / 2, width, height])
            .style('font', '15px sans-serif');

        svg.selectAll("*").remove();

        const b = {
            w: 120, h: 50, s: 3, t: 10
        };

        const trail = svg.append('g')
            .attr('class', 'trail')
            .attr('transform', `translate(${-width / 2},${height / 2 - 50})`);


        const arc = d3.arc()
            .startAngle(d => d.x0)
            .endAngle(d => d.x1)
            // .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
            .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
            // .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
            .padRadius(finalRadius * 1.5)
            // .padRadius(finalRadius)

            .innerRadius(d => d.y0 * finalRadius)
            // .outerRadius(d => Math.max(d.y0 * finalRadius, d.y1 * finalRadius - 1));
            .outerRadius(d => Math.max(d.y0 * finalRadius, d.y1 * finalRadius - 1));
        // .outerRadius(d => Math.max(d.y0 * finalRadius, d.y1 * finalRadius));

        const path = svg.append('g')
            .selectAll('path')
            .data(root.descendants())
            .join('path')
            .attr('fill', d => getColor(d))
            .attr('fill-opacity', d => arcVisible(d.current) ? (d.children ? 0.9 : 0.4) : 0)
            .attr('pointer-events', d => arcVisible(d.current) ? 'auto' : 'none')
            .attr('d', d => arc(d.current))
            .style('cursor', d => (d.children ? 'pointer' : 'default'))
            .on('click', (event, d) => {
                if (d.children) {
                    clicked(event, d);
                }
            });

        pathRef.current = path;


        path.append('title')
            // .text(d => `${d.ancestors().map(d => d.data.name).reverse().join('->')}\n${d.value}`);
            .text(d => `${d.ancestors().map(d => d.data.name).reverse().join('->')}`);

        const label = svg.append('g')
            .attr('pointer-events', 'none')
            .attr('text-anchor', 'middle')
            .style('user-select', 'none')
            .selectAll('text')
            .data(root.descendants().slice(1))
            // .data(root.descendants())
            .join('text')
            .attr('dy', '0.35em')
            .attr('fill-opacity', d => +labelVisible(d.current))
            .attr('transform', d => labelTransform(d.current))
            .text(d => d.data.name);

        labelRef.current = label;

        const middleArcLabel = svg.append('text')
            .attr('text-anchor', 'middle')
            .attr('dominant-baseline', 'middle')
            .style('font-size', '30px');

        function updateMiddleArcLabel(d, transitionDuration = 750) {
            // function updateMiddleArcLabel(d, transitionDuration = 10000) {
            const name = d.data.name;
            const nameParts = name.length > 15 ? [`${name.slice(0, 15)}-`, name.slice(12)] : [name];

            middleArcLabel
                .style('opacity', 0)
                .html(() => {
                    return nameParts.map((part, index) =>
                        `<tspan x="0" dy="${index === 0 ? 0 : 20}">${part}</tspan>`
                    ).join('');
                })
                .transition()
                .duration(transitionDuration)
                .style('opacity', 1);
        }

        const parent = svg.append('circle')
            .datum(root)
            .attr('r', finalRadius)
            .attr('fill', 'none')
            .attr('pointer-events', 'all')
            .on('click', (event, d) => clicked(event, d));

        function clicked(event, p) {
            if (!p || !p.children) return;

            try {
                parent.datum(p.parent || root);

                root.each(d => d.target = {
                    x0: Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
                    x1: Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
                    y0: Math.max(0, d.y0 - p.depth),
                    y1: Math.max(0, d.y1 - p.depth)
                });


                const t = svg.transition().duration(750);

                // Add error checking for the transition
                if (!t) return;

                path.transition(t)
                    .tween('data', d => {
                        const i = d3.interpolate(d.current, d.target);
                        return t => d.current = i(t);
                    })
                    .attr('fill-opacity', d => arcVisible(d.target) ? (d.children ? 0.9 : 0.4) : 0)
                    .attr('pointer-events', d => arcVisible(d.target) ? 'auto' : 'none')
                    .attrTween('d', d => () => arc(d.current));

                label.filter(function (d) {
                    return +this.getAttribute('fill-opacity') || labelVisible(d.target);
                }).transition(t)
                    .attr('fill-opacity', d => +labelVisible(d.target))
                    .attrTween('transform', d => () => labelTransform(d.current));

                updateBreadcrumbs(p.ancestors().reverse());
                updateMiddleArcLabel(p);
            } catch (error) {
                console.warn('Click transition error handled:', error);
            }
        }

        function arcVisible(d) {
            return d.y1 <= depth && d.y0 >= 0 && d.x1 > d.x0;
            // return d.y1 <= depth + 1 && d.y0 >= 0 && d.x1 > d.x0;
        }

        function labelVisible(d) {
            return d.y1 <= depth && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
        }

        function labelTransform(d) {
            const x = (d.x0 + d.x1) / 2 * 180 / Math.PI;
            const y = (d.y0 + d.y1) / 2 * finalRadius;
            return `rotate(${x - 90}) translate(${y},0) rotate(${x < 180 ? 0 : 180})`;
        }

        function breadcrumbPoints(d, i) {
            const points = [];
            points.push("0,0");
            points.push(`${b.w},0`);
            points.push(`${b.w + b.t},${b.h / 2}`);
            points.push(`${b.w},${b.h}`);
            points.push(`0,${b.h}`);
            if (i > 0) {
                points.push(`${b.t},${b.h / 2}`);
            }
            return points.join(" ");
        }

        function updateBreadcrumbs(nodeArray) {
            const g = trail.selectAll('g')
                .data(nodeArray, d => d.data.name);

            const entering = g.enter().append('g')
                .attr('transform', (d, i) => `translate(${i * (b.w + b.s)}, 0)`);

            entering.append('polygon')
                .attr('points', breadcrumbPoints)
                .attr('fill', d => getColor(d))
                .attr('stroke', 'black');

            entering.append('text')
                .attr('x', (b.w + b.t) / 2)
                .attr('y', b.h / 2)
                .attr('dy', '0.35em')
                .attr('text-anchor', 'middle')
                .attr('fill', 'black')
                .style('font-size', '20px')
                .html((d, i) => {
                    const name = d.data.name;
                    const parts = name.length > 12 ? [`${name.slice(0, 9)}-`, name.slice(9)] : [name];
                    const isLastNode = true;

                    // console.log(d.value); // d.value and 
                    // console.log(root.value);
                    return parts.map((part, index) =>
                        `<tspan text-anchor='start' dominant-baseline='central' x=${parts.length === 1 ? 15 : 13} y=${parts.length === 1 ? 25 : 19} dy="${index === 0 ? 0 : 15}px">${part}</tspan>`
                    ).join('') +
                        (isLastNode
                            // ? `<tspan x=${b.w + 50} y=${b.h / 2} dy="0.35em" fill='white'>${(d.value / root.value * 100).toFixed(2)}%</tspan>`
                            ? `<tspan x=${b.w + 50} y=${b.h / 2} dy="0.35em" fill='${theme.colors.text}'>${(d.value / root.value * 100).toFixed(2)}%</tspan>`
                            : '');

                });


            g.attr('transform', (d, i) => `translate(${i * (b.w + b.s)}, 0)`);

            g.exit().remove();

            trail.style('visibility', '');
        }

        updateBreadcrumbs(root.ancestors().reverse());
        updateMiddleArcLabel(root, 0);

        // if (targetNode) {
        //     setTimeout(() => {
        //         clicked(null, targetNode.parent || targetNode);
        //     }, 0);
        // }
        if (targetNode) {
            // Add a slightly longer delay and error handling
            setTimeout(() => {
                try {
                    // Check if parent exists and elements are ready
                    if (targetNode.parent && pathRef.current) {
                        clicked(null, targetNode.parent);
                    } else if (targetNode) {
                        clicked(null, targetNode);
                    }
                } catch (error) {
                    console.warn('Transition error handled:', error);
                }
            }, 500); //  delay
        }
    };

    useEffect(() => {
        if (taxaData) {
            createSunburst(taxaData);
        }
    }, [taxaData, theme, depth]);

    // useEffect(() => {
    //     if (highlightTaxon) {
    //         // Access the existing D3 elements and update them based on the new highlightTaxon
    //         // You may need to store references to your D3 selections using useRef
    //         // can you implement this? change code here
    //     }
    // }, [highlightTaxon]);

    // useEffect(() => {
    //     if (pathRef.current) {
    //         pathRef.current
    //             .transition()
    //             .duration(100)
    //             .attr('fill', d => getColor(d));
    //     }
    // }, [highlightTaxon]);

    useEffect(() => {
        if (pathRef.current && highlightTaxon) {
            pathRef.current
                .transition()
                .duration(100)
                .attr('fill', d => getColor(d))
                .on('end', () => {
                    // Reset highlightTaxon after transition completes
                    setTimeout(() => {
                        setHighlightTaxon(null);
                    }, 1000); // Wait 1 second after transition
                });
        }
    }, [highlightTaxon, setHighlightTaxon]);

    return (
        <>
            <svg ref={svgRef} style={{ width: '100%', height: '100%', overflow: 'visible' }}></svg>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <Button onClick={downloadSVG}>
                    SVG
                    <img src={downloadImage} alt="download SVG" style={{ marginLeft: '8px', height: '1em' }} />
                </Button>
                <Button onClick={downloadOTU}>
                    OTU
                    <img src={downloadImage} alt="download OTU" style={{ marginLeft: '8px', height: '1em' }} />
                </Button>
            </div>
        </>
    );
}